import logo from "../logo.svg";
import "../App.css";
import TopSlider from "../components/HomeSection/TopSlider";
import ShopCategories from "../components/HomeSection/ShopCategories";
import ProductTabs from "../components/HomeSection/ProductTabs";
import BannerSlider from "../components/HomeSection/BannerSlider";
import TrustSlider from "../components/HomeSection/TrustSlider";
import Marquee from "../components/HomeSection/Marquee";
import CustomerReviews from "../components/HomeSection/CustomerReviews";
import OurValues from "../components/HomeSection/OurValues";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import HomeFeaturedCollection from "../components/HomeSection/HomeFeaturedCollection";
import HomeCollections from "../components/HomeSection/HomeCollections";

const Home = () => {
  useEffect(() => {
    document.title = "Home | HueHoppers – Joyful Kids' Fashion";
  }, []);

  return (
    <>
      <TopSlider />
      <ShopCategories />
      <TrustSlider />

      <HomeCollections />
      <ProductTabs />
      <HomeFeaturedCollection />
      <CustomerReviews />
      <OurValues />
    </>
  );
};

export default Home;
